export default class Certificate {
    constructor(raw = {}) {
        this.username = raw.username;
        this.courseRunId = raw.courseRunId;
        this.courseName = raw.courseName;
        this.courseId = raw.courseId;
        this.manualCreated = raw.manualCreated;
        this.date = raw.date;
        this.certificateFileName = raw.certificateFileName;
    }
}
